import styles from "./styles.module.css";

const Loading = () => (
  <div className={styles.loadingContainer}>
    <img className={styles.loadingSpinner} src="/assets/icons/noun-loading.svg" alt="loader" />
  </div>
);

export default Loading;
